import Cookies from "js-cookie";
import { toast } from "react-toastify";

const BASE_URI = process.env.REACT_APP_BASE_URI;
 //const BASE_URI = "https://backend.bagh-e.com";
// const BASE_URI = "http://localhost:3000";

export const formHelper = async (
  endPoint,
  method,
  formData, // Accepts FormData object
  state1,
  state2,
  state3,
  dispatch,
  isToast = true,
  isToken = false
) => {
  try {
     console.log("API Call:", {
      endPoint, formData})
    dispatch(state1());

    // Prepare headers
    const headers = {};
    if (isToken) {
      headers.Authorization = `Bearer ${Cookies.get("auth-token")}`;
    }

    // Make API call
    const response = await fetch(`${BASE_URI}/${endPoint}`, {
      method: method,
      headers,
      body: formData, // Directly pass the FormData object
    });
    const data = await response.json();
    dispatch(state3());

    // Handle errors – ensure only one toast per call
    if (response.status === 500) {
      toast.error(data?.message || "Internal Server Error");
      return false;
    }
    if (response.status >= 400 && response.status < 500) {
      toast.error(data?.message || "Something went wrong");
      return false;
    }

    // Handle success – single success toast
    if ([200, 201, 204].includes(response.status)) {
      dispatch(state2(data));
      if (endPoint === "user/login") {
        Cookies.set("auth-token", data?.data?.token);
      }
      if (isToast) {
        toast.dismiss();
        toast.success(data.message || "Success");
      }
      return true;
    }
  } catch (error) {
    dispatch(state3());
    toast.error(error.message);
    return false;
  }
};
